import NavigatableHeader, {
  PodcastTableGoBackButton,
} from 'components/NavigatableHeader';

import DefaultSubtitle from 'pages/headliner/components/DefaultSubtitle';
import {
  useGetPodcastTitleFromSocialStatsInfo,
  useGetEpisodeTitleFromSocialStats,
} from 'pages/headliner/state';

interface TablePageTitleProps {
  podcastId: string | undefined;
  episodeId: string | undefined;
  onBackClick: () => void;
}

const TablePageTitle: React.FC<TablePageTitleProps> = ({
  podcastId,
  episodeId,
  onBackClick,
}) => {
  const { data: podcastTitle } =
    useGetPodcastTitleFromSocialStatsInfo(podcastId);
  const { data: episodeTitle } = useGetEpisodeTitleFromSocialStats(
    podcastId,
    episodeId,
  );

  const subtitle = (() => {
    if (episodeId) {
      return (
        <PodcastTableGoBackButton
          podcastTitle={podcastTitle}
          onClick={onBackClick}
        />
      );
    }
    if (podcastId) {
      return <PodcastTableGoBackButton onClick={onBackClick} />;
    }
    return <DefaultSubtitle />;
  })();

  return (
    <NavigatableHeader
      title={episodeTitle ?? podcastTitle ?? 'Podcasts Shared'}
      subtitle={subtitle}
    />
  );
};
export default TablePageTitle;
